import React from "react";
import {
  DialogContent,
  Button,
  Dialog,
  DialogActions,
  Zoom,
  CircularProgress,
  Box,
} from "@mui/material";
import { HeaderTypography } from "../../styles/style";

export default function MyDialog(props) {
  const {
    open,
    handleClose,
    handleConfirm,
    Header,
    children,
    disabled,
    textConfirm,
    actionContent = true,
    isTextCancel = true,
    isTextConfirm = true,
    textCancel,
    loading = false,
    maxHeight = 400,
    minWidth = 300,
    customStyle = {},
  } = props;

  return (
    <Dialog
      open={open}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'transparent',
            backdropFilter: 'none',
          },
        },
      }}
      hideBackdrop={true}
      onClose={handleClose}
      TransitionComponent={Zoom}
      sx={{
        overflow: "visible",
        backgroundColor: 'transparent',
        backdropFilter: 'none',
        "& .MuiPaper-root": { maxHeight, minWidth },
        ...customStyle,
      }}
    >
      {loading && (
        <Box
          sx={{
            height: "100%",
            width: "100%",
            position: "absolute",
            backdropFilter: "blur(0.6px)",
            zIndex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={80} />
        </Box>
      )}

      {Header && <HeaderTypography>{Header}</HeaderTypography>}

      <DialogContent
        sx={{ paddingRight: "0px", overflow: "auto", maxHeight: "800px", paddingBottom: "60px" }}
      >
        {children}
      </DialogContent>

      {actionContent && (
        <DialogActions>
          {isTextCancel && (
            <Button variant="outlined" onClick={handleClose}>
              {textCancel}
            </Button>
          )}

          {isTextConfirm && (
            <Button
              variant="contained"
              disabled={disabled}
              onClick={handleConfirm}
            >
              {textConfirm}
            </Button>
            )}
        </DialogActions>
      )}
    </Dialog>
  );
}
